/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  // Simple Calendar State
  events: [],
  // Calendar Labels
  eventLabels: [{color: 'primary' ,value : '개인', text:'개인 일정'},
  {color:'warning',value: '결과물' , text:'결과물 일정'}]
  // {color:'success',value: '개인' , text:'개인 일정'}]
}
